import axios from 'axios';

const $axios = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL,
    // baseURL: 'https://trialit2.nasmoco.co.id/pwa/api/v1/',
    // baseURL: 'http://localhost/api-nasmoco-master/',
    // baseURL: 'https://api.ufotostudio.com/v1/',
    // baseURL: 'http://localhost:902/cmspwa.nasmoco.co.id/pwa/api/v1/',
    // baseURL: 'http://localhost:99/cmspwa/pwa/api/v1/',
    // baseURL: 'https://cmspwa.nasmoco.co.id/pwa/api/v1/',

    // PENTING: batas waktu 30 detik.
    // Tanpa timeout, request yang menggantung (server tidak menjawab,
    // koneksi di-drop firewall, PHP hang) membuat Promise TIDAK PERNAH
    // selesai. Akibatnya flag loading_* di Vuex menyala selamanya dan
    // halaman terlihat blank. Dengan timeout, request gagal cepat lalu
    // ditangani oleh .catch() di masing-masing action store.
    timeout: 30000,

    headers: {
        'Content-Type': 'application/json',
        'x-api-key': process.env.VUE_APP_API_KEY
    }
});

export default $axios;